module.exports = __webpack_public_path__ + "static/koffee_cup-81dc9a703d8f88dc581fe8e083dcd666.png";